/* eslint-disable arrow-body-style */
import React from 'react';
import ChatBot from 'react-simple-chatbot';
import { VetChatHeader } from '../VetChatHeader';
export const ChatbotDesktop = ({
  steps,
  vetAssistantImg
}) => {
  return <ChatBot steps={steps} avatarStyle={{
    boxShadow: 'none'
  }} botAvatar={vetAssistantImg} botDelay={5000} bubbleStyle={{
    borderRadius: '8px'
  }} contentStyle={{
    bg: 'white',
    height: '300px'
  }} headerComponent={<VetChatHeader />} hideUserAvatar inputStyle={{
    fontFamily: 'muli',
    boxShadow: '0 -3px 7px 0 rgba(16,41,65,0.09)'
  }} placeholder="Tell us about your pet..." style={{
    height: 'auto',
    width: '100%',
    boxShadow: '0 0 9px 0 rgba(0,0,0,0.16)'
  }} userDelay={100} data-sentry-element="ChatBot" data-sentry-component="ChatbotDesktop" data-sentry-source-file="index.tsx" />;
};